(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-testimonials-grid"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const items = document.querySelectorAll('.enact-testimonials-wrapper .read__more')
        items.forEach( item => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                document.querySelector(`.${item.dataset.id}`).classList.add('active')
            })
        })
        document.querySelectorAll('.__testimonial-item-lightbox-wrapper').forEach( wrapper => {
            wrapper.addEventListener('click', (event) => {
                if(event.target === wrapper.querySelector('.__testimonial-item-lightbox-inner')) {
                    wrapper.classList.remove('active')
                }
            })
        })
    })

  } catch(e) { console.error(e); }
})();
})();
